export default (value) => String(value).replace(/\D/g, '');
